import React from 'react'

import './index.css'

/** Blocking loading veil; `withoutLoadingIcon` keeps the veil alone (a dialog shows its own progress). */
export default function LoadingScreen({ withoutLoadingIcon = false }) {
    return (
        <div className="loading-screen-container" role="status" aria-live="polite" aria-busy="true">
            {!withoutLoadingIcon && (
                <span className="loading-screen-tile">
                    <span className="loading-screen-spinner" aria-hidden="true" />
                </span>
            )}
        </div>
    )
}
